<template>
	<div class="app-container">
		<div class="filter-container">
			<el-form ref="queryForm" inline :model="listQuery" @submit.native.prevent>
				<el-form-item>
					<el-row>
						<el-date-picker v-model="listQuery.search_time" type="datetimerange" range-separator="-"
							start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss">
						</el-date-picker>
					</el-row>
				</el-form-item>
				<el-form-item>
					<el-select v-model="listQuery.serial_id" clearable filterable placeholder="请选择设备序列号">
						<el-option v-for="item in serialData" :key="item.id" :label="item.serial_name+'-'+item.serial_number"
							:value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" icon="el-icon-search" @click="SearchData">搜索</el-button>
					<el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
				</el-form-item>
			</el-form>
		</div>
		<!--动作组-->
		<div class="action-container">
			<el-button-group>
				<!-- 弹窗层编辑 -->
				<el-button v-auth="'Space.create'" class="action-item" type="primary" icon="el-icon-edit"
					@click="HandleCreate">添加</el-button>
				<el-button v-auth="'Space.delete'" class="action-item" icon="el-icon-delete" @click="BatchDelete">删除</el-button>
				<el-button type="success" @click="goBack()">返回场地</el-button>
			</el-button-group>
		</div>
		<!--表开始-->
		<el-table ref="singleTable" v-loading="listLoading" :data="list" border fit highlight-current-row
			style="width: 100%" @sort-change="sortChange">
			<!--列开始-->
			<el-table-column type="selection"></el-table-column>
			<el-table-column type="index" label="序号" width="55" :index="indexMethod" align="center" />
			<el-table-column align="center" prop="site_name" label="所属门店"> </el-table-column>
			<el-table-column align="center" prop="space_name" label="所属场地"> </el-table-column>
			<el-table-column align="center" prop="start_time" label="视频开始时间"> </el-table-column>
			<el-table-column align="center" prop="end_time" label="视频结束时间"> </el-table-column>
			<el-table-column align="center" prop="video_url" label="场地视频">
				<template slot-scope="scopes">
					<video :key="scopes.row.id" controls width="200" height="150" :poster="scopes.row.cover">
						<source :src="scopes.row.video_url">
					</video>
				</template>
			</el-table-column>
			<el-table-column align="center" prop="order_no" label="排序 "> </el-table-column>
			<el-table-column align="center" prop="create_time" label="创建时间 "> </el-table-column>
			<el-table-column align="center" prop="" label="操作" width="200" class-name="action">
				<template slot-scope="scopes">
					<el-button v-auth="'Space.update'" icon="el-icon-edit" type="primary" size="mini"
						@click="HandleUpdate(scopes.row)">编辑</el-button>
					<el-button v-auth="'Space.delete'" icon="el-icon-delete" size="mini" type="danger"
						@click="RowDelete(scopes.row)">删除</el-button>
				</template>
			</el-table-column>
			<!--列结束-->
		</el-table>
		<!--分页-->
		<pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit"
			@pagination="loadData" />
		<!--弹窗编辑/新增窗体-->
		<el-dialog :title="dialogStatus=='create'?'新增':'编辑'" :visible.sync="dialogFormVisible">
			<el-form ref="dataForm" :rules="rules" :model="temp" label-position="left" label-width="110px"
				style="width: 100%;">
				<el-form-item label="视频时间" prop="time">
					<el-row>
						<el-date-picker v-model="temp.time" type="datetimerange" range-separator="-" start-placeholder="开始日期"
							end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss">
						</el-date-picker>
					</el-row>
				</el-form-item>
				<el-form-item label="设备序列号" prop="serial_id">
					<el-select v-model="temp.serial_id" placeholder="请选择设备序列号">
						<el-option v-for="item in serialData" :key="item.id" :label="item.serial_name+'-'+item.serial_number"
							:value="item.id" @click.native="temp.serial_name=item.serial_name">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="场地视频" prop="video_url">
					<FileList v-model="temp.video_url" :item-width="300" :item-height="300" :limit="1" type="video" />
				</el-form-item>
				<el-form-item label="排序" prop="order_no">
					<el-input-number v-model="temp.order_no" :min="1" :max="99999" />
					<p class="tishi">排序越小，小程序展示越靠前</p>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false">取消</el-button>
				<el-button type="primary" @click="save()">保存</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import api from '@/api/site/spaceVideo' // 和数据交互相关写在api 方便复用
	import serialapi from '@/api/site/spaceSerial' // 和数据交互相关写在api 方便复用
	import Pagination from '@/components/Pagination' // 分页 给予 el-pagination 的二次封装
	import commonList from '@/utils/commonList'
	import FileList from '@/components/attachment/FileList'
	export default {
		name: 'SpaceVideo',
		components: {
			Pagination,
			FileList
		},
		// 列绑定格式化器
		filters: {},
		mixins: [commonList],
		data() {
			return {
				// api接口方法
				api,
				// 校验
				rules: {
					time: [{
						required: true,
						message: '请选择视频时间',
						trigger: 'blur,change'
					}],
					serial_id: [{
						required: true,
						message: '请选择设备序列号',
						trigger: 'blur,change'
					}],
					video_url: [{
						required: true,
						message: '请上传视频',
						trigger: 'blur,change'
					}]
				},
				temp: {},
				listQuery: {
					page: 1,
					limit: 10, // 页大小
					order: 'DESC', // 默认排序方式,
					sort: 'id',
					serial_id: ''
				},
				serialData: []
			}
		},
		watch: {
			'temp.video_url': {
				handler(newValue, oldValue) {
					this.$refs.dataForm.validateField('video_url')
				}
			}
		},
		created() {
			this.listQuery.site_id = this.$route.query.site_id
			this.listQuery.space_id = this.$route.query.id
			this.loadData()
			this.getserial()
		},
		methods: {
			// 查询设备序列号
			getserial() {
				serialapi.Query({
					site_id: this.listQuery.site_id,
					space_id: this.listQuery.space_id,
					isPaginator: false,
					sort: 'id',
					order: 'desc'
				}).then((response) => {
					this.serialData = response.data
					console.log(response.data, '++++++++++++++++++++++++++++')
				})
			},
			// 条件过滤查询
			SearchData() {
				this.listQuery.site_id = this.$route.query.site_id
				this.listQuery.space_id = this.$route.query.id
				this.listQuery.page = 1
				if (this.listQuery.start_time > this.listQuery.end_time) {
					this.$message({
						message: '开始时间不能大于结束时间',
						type: 'warning'
					})
					return
				}
				this.loadData()
			},
			// 显示编辑窗体
			HandleUpdate(row) {
				this.temp = Object.assign({}, row) // copy obj
				this.dialogStatus = 'update'
				this.dialogFormVisible = true
			},
			goBack() {
				this.$router.push({
					path: '/site/space'
				})
			},
			// 提交
			save() {
				this.temp.space_id = this.$route.query.id
				this.temp.site_id = this.$route.query.site_id
				const obj = {
					...this.temp
				}
				this.$refs['dataForm'].validate((valid) => {
					if (valid) {
						api.Create(obj).then((response) => {
							this.$notify({
								title: '成功',
								message: response.msg,
								type: 'success',
								duration: 2000
							})
							this.loadData()
							this.dialogFormVisible = false
						})
					}
				})
			},
			resetTemp() {
				this.temp = {
					id: undefined,
					serial_id: '',
					serial_name: '',
					order_no: 99999
				}
			}
		}
	}
</script>